import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex flex-col items-center"
      >
        <div className="w-20 h-20 rounded-xl overflow-hidden bg-white shadow-2xl mb-6">
          <img 
            src="/logo.png" 
            alt="Loading" 
            className="w-full h-full object-contain"
          />
        </div>
        <Loader2 className="w-8 h-8 text-red-500 animate-spin mb-4" />
        <p className="text-zinc-400 text-sm">{message}</p>
      </motion.div>
    </div>
  );
};

export default LoadingScreen;
